<script setup lang="ts">
// import NavScheduleItems from './NavScheduleItems.vue'
// import { ref } from 'vue'
import { retrieveNotificationCount } from '@/composables/notification/notifications'
import { onMounted, onUnmounted } from 'vue'
import { useRouter } from 'vue-router'
import { useLifeListStore } from '@/composables/life/life'

const router = useRouter()

const emit = defineEmits(['onSelect'])

onMounted(() => {
  retriveUnreadLooply()
})

function onSelectAction(action: string) {
  emit('onSelect', action)
}

// define retriveInterval
let retriveInterval: ReturnType<typeof setInterval>

function retriveUnreadLooply() {
  // every 3 minutes to call retrieveNotificationCount() one time
  retrieveNotificationCount()
  retriveInterval = setInterval(() => {
    retrieveNotificationCount()
  }, 180 * 1000) // 180s (3 minutes)
}

onUnmounted(() => {
  if (retriveInterval) {
    clearInterval(retriveInterval)
  }
})

function onCreateLife() {
  router.push('/guide/createLifeAndBaseInfo')
  onSelectAction('createLife')
}

const lifeListStore = useLifeListStore()
</script>
<template>
  <div w-full relative mb-10>
    <NavItem icon="i-octicon:home-24" name="menu.home" category="home" url="/home" @onAction="onSelectAction" />
    <NavItem
      icon="i-solar:book-linear"
      name="menu.life_page"
      category="lifepage"
      url="/life/list"
      @onAction="onSelectAction">
      <template #action>
        <div v-if="lifeListStore.state === 'loading'" flex="~ row" w-6 h-6 items-center>
          <div i-eva:loader-outline text-second animate-spin text-xl></div>
        </div>
        <el-tooltip
          v-if="lifeListStore.state !== 'loading'"
          :content="$t('tip.add_page')"
          placement="top"
          effect="light"
          :show-after="500">
          <RIcon icon="i-ion:add-sharp" @click="onCreateLife"></RIcon>
        </el-tooltip>
      </template>
      <template #children>
        <NavLifePageItems :expandSize="8" @onItemSelect="onSelectAction"></NavLifePageItems>
      </template>
    </NavItem>
    <NavItem
      icon="i-quill:calendar"
      name="menu.memorize_day"
      category="schedule"
      url="/schedule"
      @onAction="onSelectAction">
    </NavItem>

    <NavItem
      icon="i-ion:people-outline"
      name="menu.history"
      category="history"
      url="/life/history"
      @onAction="onSelectAction"></NavItem>
    <NavItem icon="i-codicon:note" name="m.obituary" category="obituary" url="/obituaryList" @onAction="onSelectAction">
    </NavItem>
    <NavItem
      icon="i-ic:baseline-portrait"
      name="portrait.title"
      category="portrait"
      url="/portrait"
      @onAction="onSelectAction">
    </NavItem>
    <NavItem
      icon="i-ph:bell"
      name="menu.notification"
      category="notification"
      url="/notification"
      @onAction="onSelectAction"></NavItem>
    <NavItem
      icon="i-ph:archive-box"
      name="menu.archive"
      category="archive"
      url="/life/archive"
      @onAction="onSelectAction">
    </NavItem>
    <NavItem
      icon="i-carbon:settings"
      name="menu.setting"
      category="settings"
      url="/settings"
      @onAction="onSelectAction">
    </NavItem>
  </div>
</template>
<style lang="scss" scoped></style>
